/* global mixpanel */
export function settingAccountStart () {
  mixpanel.track('Setting Account Start')
}



// WEBPACK FOOTER //
// ./app/mixpanel/settings/accounts.js